import styled from '@emotion/styled';
import { Modal, Stack, colors } from '@ui-components/neo.tax';

import { screenLg, screenXl } from '@neo.tax/shared/utils/media.utils';

import { KeywordSearch } from '../keyword-search';

export const StyledModal = styled(Modal)({
  minHeight: 500,
  padding: 0,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const StyledSlidersStack = styled(Stack)(
  {
    height: 450,
    overflow: 'hidden',
    width: 976,
  },
  screenXl({
    width: '100%',
  }),
);

export const Divider = styled.div({
  height: '100%',
  width: 1,
  backgroundColor: colors.gray[100],
});

export const StyledBreakdownContainer = styled(Stack)({
  width: 360,
});

export const StyledStack = styled(Stack)(
  {
    overflowY: 'auto',
    maxHeight: 380,
    flex: 1,
    '& > li:last-of-type': {
      paddingBottom: 48,
    },
    width: '100%',
  },
  screenLg({
    width: 340,
  }),
  screenXl({
    width: 350,
  }),
);

export const StyledKeywordSearch = styled(KeywordSearch)({
  maxBlockSize: 'fit-content',
});

export const StyledLeftColumn = styled(Stack)({
  width: '50%',
  height: 440,
  overflow: 'hidden',
});

export const StyledRightColumn = styled(Stack)({
  width: '50%',
  height: 440,
  overflow: 'hidden',
});

export const StyledHeaderPlaceholder = styled(Stack)({
  maxHeight: 66,
  minHeight: 66,
});
